let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h7X9I")).then(() => parcelRequire('3RtAx'));